import { translate } from 'translations/i18n';

const riskDisclaimerProps = {
  firstColumn: translate('presale.radColumns.firstColumn'),
  secondColumn: translate('presale.radColumns.secondColumn'),
};

export default riskDisclaimerProps;
